<textarea
  id="message"
  rows="4"
  [formControl]="control"
  [disabled]="disabled"
  class="block p-2.5 w-full text-sm text-gray-900 rounded-lg border border-black focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-800 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
  [placeholder]="placeholder"></textarea>
